// Etiquetas y formato de pagos CCCD compartidos por las pantallas de pago manual y de equipo,
// para no mostrar valores crudos del API (bank_transfer_national) ni formatos de monto distintos.

export const PAYMENT_METHOD_LABELS: Record<string, string> = {
  bank_transfer_national: "Transferencia nacional",
  bank_transfer_international: "Transferencia internacional",
  wompi: "Wompi",
}

export const paymentMethodLabel = (method: string): string => PAYMENT_METHOD_LABELS[method] ?? method

/** COP sin decimales, según el default del ecosistema (es-CO). */
export const formatCop = (amount: number): string =>
  new Intl.NumberFormat("es-CO", { style: "currency", currency: "COP", maximumFractionDigits: 0 }).format(amount)
